module.exports = __webpack_public_path__ + "img/GHS06.c941ad4f.webp";